/**
 * Yvine Design — events page (upcoming/past lists, calendar grid, add-to-calendar).
 * Cached asset, initialised once per [data-art="events"] element by art-core.js
 * (first paint, every in-place page swap, theme-editor reloads).
 */
Art.section('events', function (root) {
        // Cards and this month's grid are server-rendered (sections/art-events.liquid);
    // here: the "Add to calendar" menus and prev / next month navigation.
    var calWrap = root.querySelector('[data-events-cal]');
    var calGrid = root.querySelector('[data-cal-grid]');
    var calLabel = root.querySelector('[data-cal-label]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-event]'));
    if (!cards.length) return;

    var now = new Date();
    var MONTHS = (calWrap && calWrap.getAttribute('data-months') || 'January,February,March,April,May,June,July,August,September,October,November,December').split(',');

    var events = cards.map(function (card) {
      var start = new Date(card.getAttribute('data-start'));
      var endRaw = card.getAttribute('data-end');
      var end = endRaw ? new Date(endRaw) : new Date(start.getTime() + 2 * 60 * 60 * 1000);
      return {
        id: card.getAttribute('data-id'),
        title: card.getAttribute('data-title') || '',
        url: card.getAttribute('data-url') || '',
        location: card.getAttribute('data-location') || '',
        number: card.getAttribute('data-number') || '',
        time: (card.querySelector('.art-ecard__time') || {}).textContent || '',
        node: card,
        start: start,
        end: end
      };
    }).filter(function (e) { return !isNaN(e.start.getTime()); });
    if (!events.length || !calWrap || !calGrid) return;

    // Wire "Add to calendar" dropdown on every card.
    root.querySelectorAll('[data-cal]').forEach(function (wrap) {
      var card = wrap.closest('[data-event]');
      if (!card) return;
      var toggle = wrap.querySelector('[data-cal-toggle]');
      var menu = wrap.querySelector('[data-cal-menu]');
      var google = wrap.querySelector('[data-cal-google]');
      var icsBtn = wrap.querySelector('[data-cal-ics]');

      if (google) google.href = googleCalUrl(card);

      function close() { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
      function open() { menu.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (menu.hidden) { closeAllCalMenus(); open(); } else { close(); }
      });
      if (icsBtn) icsBtn.addEventListener('click', function () { downloadIcs(card); close(); });
      menu.addEventListener('click', function (e) { e.stopPropagation(); });
      wrap._closeCal = close;
    });

    function closeAllCalMenus() {
      root.querySelectorAll('[data-cal]').forEach(function (w) { if (w._closeCal) w._closeCal(); });
    }
    document.addEventListener('click', closeAllCalMenus);

    // ---- Tap a day: one event → scroll its row into view and flash it;
    //      several → list them in the day strip under the grid. ----
    var strip = root.querySelector('[data-day-strip]');
    var byId = {};
    events.forEach(function (e) { byId[e.id] = e; });
    function pulse(node) {
      node.classList.remove('is-pulse');
      void node.offsetWidth;
      node.classList.add('is-pulse');
      setTimeout(function () { node.classList.remove('is-pulse'); }, 3500);
    }
    // Scroll only when the card is not fully in view, and only as far as needed
    // (bottom edge just above the app bar / viewport bottom, or top under the header).
    function scrollParentOf(el) {
      for (var p = el.parentElement; p; p = p.parentElement) {
        var o = getComputedStyle(p).overflowY;
        if ((o === 'auto' || o === 'scroll') && p.scrollHeight > p.clientHeight) return p;
      }
      return null;
    }
    function reveal(node) {
      var r = node.getBoundingClientRect();
      var nav = document.querySelector('.art-header__appnav');
      var navH = nav && nav.getClientRects().length ? nav.getBoundingClientRect().height : 0;
      var head = document.getElementById('header-group');
      var top = head ? head.getBoundingClientRect().bottom : 0;
      var limit = window.innerHeight - navH - 12;
      var delta = 0;
      if (r.bottom > limit) delta = r.bottom - limit;
      else if (r.top < top + 12) delta = r.top - (top + 12);
      if (!delta) return;
      var sp = scrollParentOf(node);
      (sp || window).scrollBy({ top: delta, behavior: 'smooth' });
    }
    function showStrip(list, cell) {
      if (!strip) return;
      strip.innerHTML = list.map(function (e) {
        return '<a class="art-events__daystrip-item" href="#event-' + escAttr(e.id) + '" data-strip-id="' + escAttr(e.id) + '">' +
          (e.number ? '<span class="art-events__num">' + escHtml(e.number) + '</span>' : '') +
          '<span class="art-events__daystrip-title">' + escHtml(e.title) + '</span>' +
          '<span class="art-events__daystrip-time">' + escHtml(e.time.trim()) + '</span></a>';
      }).join('');
      strip.hidden = false;
      strip.setAttribute('data-day', cell.getAttribute('data-day'));
    }
    // Desktop: hovering a day warms up its event page(s) through the page-swap cache.
    root.addEventListener('mouseover', function (ev) {
      var cell = ev.target.closest('a.art-events__cell[data-ids]');
      if (!cell || !window.ArtNav) return;
      (cell.getAttribute('data-ids') || '').split(',').forEach(function (id) { if (byId[id]) window.ArtNav.prefetch(byId[id].url); });
    }, { passive: true });

    root.addEventListener('click', function (ev) {
      var item = ev.target.closest('[data-strip-id]');
      if (item && byId[item.getAttribute('data-strip-id')]) {
        ev.preventDefault();
        var target = byId[item.getAttribute('data-strip-id')].node;
        reveal(target);
        pulse(target);
        return;
      }
      var cell = ev.target.closest('a.art-events__cell[data-ids]');
      if (!cell || !root.contains(cell)) return;
      var list = (cell.getAttribute('data-ids') || '').split(',').filter(Boolean).map(function (id) { return byId[id]; }).filter(Boolean);
      if (!list.length) return; // no card on the page: let the anchor do its thing
      ev.preventDefault();
      if (list.length === 1) {
        if (strip) strip.hidden = true;
        reveal(list[0].node);
        pulse(list[0].node);
      } else if (strip && !strip.hidden && strip.getAttribute('data-day') === cell.getAttribute('data-day')) {
        strip.hidden = true; // second tap closes it
      } else {
        showStrip(list, cell);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllCalMenus(); });

    // ---- Calendar grid ----
    function ymd(d) { return d.getFullYear() + '-' + d.getMonth(); }
    function dayKey(d) { return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate(); }

    // Group events by exact day for cell placement.
    var byDay = {};
    events.forEach(function (e) {
      var k = dayKey(e.start);
      (byDay[k] = byDay[k] || []).push(e);
    });

    // Continuous month range from earliest → latest event month.
    var months = events.map(function (e) { return new Date(e.start.getFullYear(), e.start.getMonth(), 1); });
    months.sort(function (a, b) { return a - b; });
    var first = months[0];
    var last = months[months.length - 1];
    var monthList = [];
    var cursor = new Date(first.getFullYear(), first.getMonth(), 1);
    while (cursor <= last) {
      monthList.push(new Date(cursor.getFullYear(), cursor.getMonth(), 1));
      cursor.setMonth(cursor.getMonth() + 1);
    }

    // Start on the month the server rendered (data-cal-view = "YYYY-MM").
    var view = 0;
    var serverView = calWrap.getAttribute('data-cal-view') || '';
    monthList.forEach(function (m, i) {
      var key = m.getFullYear() + '-' + ('0' + (m.getMonth() + 1)).slice(-2);
      if (key === serverView) view = i;
    });

    var prevBtn = root.querySelector('[data-cal-prev]');
    var nextBtn = root.querySelector('[data-cal-next]');

    function renderMonth() {
      var m = monthList[view];
      var year = m.getFullYear();
      var month = m.getMonth();
      calLabel.textContent = MONTHS[month] + ' ' + year;

      // Monday-first offset for the 1st of the month.
      var firstDow = (new Date(year, month, 1).getDay() + 6) % 7;
      var daysInMonth = new Date(year, month + 1, 0).getDate();

      var html = '';
      for (var i = 0; i < firstDow; i++) {
        html += '<div class="art-events__cell art-events__cell--empty"></div>';
      }
      for (var day = 1; day <= daysInMonth; day++) {
        var key = year + '-' + month + '-' + day;
        var dayEvents = byDay[key] || [];
        var isToday = (year === now.getFullYear() && month === now.getMonth() && day === now.getDate());
        var upcoming = dayEvents.some(function (e) { return e.end >= now; });
        var cls = 'art-events__cell';
        if (dayEvents.length) cls += ' has-events';
        if (upcoming) cls += ' is-upcoming';
        if (isToday) cls += ' is-today';
        var num = '<span class="art-events__cell-num">' + day + '</span>';
        if (dayEvents.length) {
          var nums = dayEvents.filter(function (e) { return e.number; }).map(function (e) { return '<span class="art-events__num">' + escHtml(e.number) + '</span>'; }).join('');
          var chips = dayEvents.map(function (e) { return '<span class="art-events__chip">' + escHtml(e.title) + '</span>'; }).join('');
          html += '<a class="' + cls + '" href="#event-' + escAttr(dayEvents[0].id) + '" data-day="' + key + '" data-ids="' + dayEvents.map(function (e) { return e.id; }).join(',') + ',"' +
            ' title="' + escAttr(dayEvents.length === 1 ? dayEvents[0].title : String(dayEvents.length)) + '">' + num +
            (nums ? '<span class="art-events__nums">' + nums + '</span>' : '') +
            '<span class="art-events__cell-events">' + chips + '</span></a>';
        } else {
          html += '<div class="' + cls + '">' + num + '</div>';
        }
      }
      if (strip) strip.hidden = true;
      calGrid.innerHTML = html;

      prevBtn.disabled = view === 0;
      nextBtn.disabled = view === monthList.length - 1;
    }

    prevBtn.addEventListener('click', function () { if (view > 0) { view--; renderMonth(); } });
    nextBtn.addEventListener('click', function () { if (view < monthList.length - 1) { view++; renderMonth(); } });

    // This month is already in the HTML; only the nav state is needed now.
    prevBtn.disabled = view === 0;
    nextBtn.disabled = view === monthList.length - 1;

    // ---- Helpers ----
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function icsStamp(d) {
      return d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate()) + 'T' +
        pad(d.getUTCHours()) + pad(d.getUTCMinutes()) + pad(d.getUTCSeconds()) + 'Z';
    }
    function escHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function escAttr(s) { return escHtml(s); }
    function icsEscape(s) { return String(s).replace(/([,;\\])/g, '\\$1').replace(/\n/g, '\\n'); }

    // Read the shared event fields off a card's data-* attributes.
    function eventData(card) {
      var title = card.getAttribute('data-title') || 'Event';
      var url = card.getAttribute('data-url') || '';
      var loc = card.getAttribute('data-location') || '';
      var start = new Date(card.getAttribute('data-start'));
      var endRaw = card.getAttribute('data-end');
      var end = endRaw ? new Date(endRaw) : new Date(start.getTime() + 2 * 60 * 60 * 1000);
      var origin = window.location.origin;
      var absUrl = url.indexOf('http') === 0 ? url : origin + url;
      return { title: title, loc: loc, start: start, end: end, absUrl: absUrl, id: card.getAttribute('data-id') };
    }

    // Pre-filled Google Calendar event link (opens in a new tab).
    function googleCalUrl(card) {
      var e = eventData(card);
      var params = [
        'action=TEMPLATE',
        'text=' + encodeURIComponent(e.title),
        'dates=' + icsStamp(e.start) + '/' + icsStamp(e.end),
        'details=' + encodeURIComponent(e.absUrl),
        'location=' + encodeURIComponent(e.loc)
      ];
      return 'https://calendar.google.com/calendar/render?' + params.join('&');
    }

    function downloadIcs(card) {
      var e = eventData(card);
      var title = e.title, loc = e.loc, start = e.start, end = e.end, absUrl = e.absUrl;

      var ics = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Yvine Design//Events//EN',
        'CALSCALE:GREGORIAN',
        'BEGIN:VEVENT',
        'UID:' + (e.id || Date.now()) + '@yvine',
        'DTSTAMP:' + icsStamp(new Date()),
        'DTSTART:' + icsStamp(start),
        'DTEND:' + icsStamp(end),
        'SUMMARY:' + icsEscape(title),
        'LOCATION:' + icsEscape(loc),
        'DESCRIPTION:' + icsEscape(absUrl),
        'URL:' + absUrl,
        'END:VEVENT',
        'END:VCALENDAR'
      ].join('\r\n');

      var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = (title.replace(/[^\w\- ]+/g, '').trim() || 'event') + '.ics';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
    }
});
